import * as React from "react";
import { Routes, Route } from "react-router-dom";

import SignIn from "../../pages/singin/login";
import { Forbidden } from "../../pages/erro/forbidden";
import { AzureSignOn } from "../../pages/usuarios/AzureSignOn";

export const RotasNaoAutenticadas = () => {
  return (
    <React.Fragment>
      <Routes>
        <Route path="/" element={<SignIn />} />
        <Route path="/Usuario/AzureSignOn" element={<AzureSignOn /> } />
        <Route path="/forbidden" element={<Forbidden />} />
      </Routes>
    </React.Fragment>
  );
};
